// @ts-check
import { useMutation } from '@tanstack/react-query';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import api from 'modules/queries/api';
import useInvalidateAssets from 'modules/queries/invalidateQueries/useInvalidateAssets';

const useServerUpdate = () => {
	const snackbarError = useSnackbarError();
	const invalidateAssets = useInvalidateAssets();

	return useMutation({
		mutationFn:
			/** @param {import('club-sauce/public/server/index.raw').LWApiPublicServerUpdateParamsRawI} params */
			(params) => api.server.apiRaw.update(params),
		onSuccess: (data, params) => {
			invalidateAssets(params.uniq_id);
		},
		onError: snackbarError,
	});
};

export default useServerUpdate;
